// Every handball incident type LSports can send (see the provider's
// "Handball – Incident ID / Incident Name / Kind" list), classified for the
// HandballArena:
//   key      – i18n key of the incident name shown on the court
//   alias    – same real-world event as another type: treated as that type
//   goalKind – not an incident of its own: labels the goal it comes with
//   ignore   – not a court incident: player-level stats, percentages,
//              records, timers, status/meta records
// `track: false` = an event type we react to only when the feed names it as
// CurrentIncident, not when its statistic goes up.
export const HANDBALL_SPORT_ID = '35709';

export const HANDBALL_INCIDENTS = {
    6: {key: 'handball.yellowcard'},
    7: {key: 'handball.redcard'},
    8: {alias: 2036},                           // Penalties = 7-metre throw
    9: {key: 'handball.goal', track: false},    // goals come from the scoreboard
    11: {key: 'handball.inpossession', track: false},
    16: {key: 'handball.blockedshot'},
    27: {alias: 9},                             // Score
    31: {key: 'handball.timeout'},
    96: {key: 'handball.save'},
    109: {ignore: true},
    1028: {ignore: true},
    1030: {ignore: true},
    1036: {ignore: true},
    2011: {ignore: true},                       // BiggestLead
    2035: {key: 'handball.steal'},
    2036: {key: 'handball.sevenmetre'},
    2037: {key: 'handball.twominutes'},
    2038: {key: 'handball.technicalfault'},
    2039: {ignore: true},
    2040: {ignore: true},
    2041: {ignore: true},
    2046: {key: 'handball.shot'},
    2157: {ignore: true},                       // Max goals in a row
    2174: {key: 'handball.bluecard'},
    2177: {goalKind: 'handball.shorthandedgoal'},
    2277: {ignore: true},                       // Period (scoreboard)
    2278: {ignore: true},                       // FixtureStatus (scoreboard)
    2279: {ignore: true},                       // Timer (scoreboard)
    2280: {ignore: true},
    2366: {ignore: true},
    2368: {ignore: true},
    2423: {breakTime: true, ignore: true},      // BreakTime: drives the half-time phase
    2441: {goalKind: 'handball.powerplaygoal'},
    2462: {ignore: true},                       // StatusDescription
    2616: {ignore: true},                       // CurrentIncident record itself
    2619: {ignore: true}                        // ExtraData record
};

// { type, ignored, known, breakTime } for a raw provider type.
export function resolveHandballType(rawType) {
    const t = parseInt(rawType) || 0;
    const def = HANDBALL_INCIDENTS[t];
    if (!def) return {type: t, ignored: false, known: false, breakTime: false};
    if (def.alias) return {type: def.alias, ignored: false, known: true, breakTime: false};
    return {type: t, ignored: !!def.ignore, known: true, breakTime: !!def.breakTime};
}

// Stats that go up together with a goal and say what kind of goal it was.
export const HANDBALL_GOAL_KINDS = Object.keys(HANDBALL_INCIDENTS)
    .map(Number)
    .filter(t => HANDBALL_INCIDENTS[t].goalKind)
    .reduce((all, t) => ({...all, [t]: HANDBALL_INCIDENTS[t].goalKind}), {});

// Team statistics whose increase is read as "this just happened" (the
// goal-kind ones too: they're folded into the goal they come with).
export const HANDBALL_STATS_TO_TRACK = Object.keys(HANDBALL_INCIDENTS)
    .map(Number)
    .filter(t => {
        const def = HANDBALL_INCIDENTS[t];
        return (def.key && def.track !== false) || def.goalKind;
    });

export function handballIncidentKey(type) {
    const def = HANDBALL_INCIDENTS[type];
    return def && def.key ? def.key : null;
}
